import { rem } from 'polished';
import styled from 'styled-components';

export const Wrapper = styled.div`
  .counsellor-profile {
    margin: 0 0 ${rem(24)};
  }

  .appointment {
    margin-top: ${rem(20)};
    margin-bottom: 0;

    span {
      font-size: ${rem(14)};
      vertical-align: text-top;
    }

    svg {
      margin-right: ${rem(8)};
    }
  }

  .appt-times {
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  .time-choices {
    margin-top: ${rem(12)};
    margin-bottom: ${rem(20)};

    ul {
      margin-top: 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: ${rem(16)};
    }

    li {
      margin-bottom: 0;
    }

    label {
      justify-content: center;
    }
  }

  .policy-details {
    margin: 0;
    font-size: ${rem(14)};
  }

  button.start-again {
    margin-top: ${rem(24)};
    width: 100%;
  }

  .card.info {
    margin-bottom: ${rem(24)};
  }
`;
